import { FormGroup } from '@angular/forms';
import {
  FormRule,
  FormRuleEffect,
  FormRuleFactory,
  RuleAction,
} from 'src/app/shared/forms';
import { SubmissionConstants } from '../../models/constants/submissions-constants';
import { CustomerInfoRules } from './customerRules';
import { ManufactureDateRules } from './manufactureDateRules';
import { HeatPumpDocumentRules } from './heatPumpDocumentRules';

export class SbraV2CustomRules {
  constructor(
    private ruleFact: FormRuleFactory,
    private submissionsConst: SubmissionConstants,
  ) {}

  getCustomRules(subValues: FormGroup): FormRule[] {
    return [
      ...new CustomerInfoRules(
        this.ruleFact,
        this.submissionsConst,
      ).getCustomRules(subValues),
      ...new ManufactureDateRules(
        this.ruleFact,
        this.submissionsConst,
      ).getCustomRules(subValues),
      ...new HeatPumpDocumentRules(
        this.ruleFact,
        this.submissionsConst,
      ).getV2CustomRules(subValues),
      ...this.getDesignPackageRules(subValues),
    ];
  }

  private getDesignPackageRules(subValues: FormGroup): FormRule[] {
    const status = subValues.get('status').value;
    const designPackage = subValues.get('designPackage').value;
    const shouldMarkDesignPackageRequired =
      (status === this.submissionsConst.statusReadyToSubmit ||
        status === this.submissionsConst.statusSubmittedManually) &&
      designPackage === null;

    const isEhpDesignPackage =
      this.submissionsConst.designPackageEhpOptions.includes(designPackage);

    const applyEffect = (action: RuleAction, value?: string) =>
      this.createBaseEffect(action, 'designPackage', value);

    return [
      this.ruleFact.createRule(`${shouldMarkDesignPackageRequired}`, [
        applyEffect(RuleAction.MAKE_INVALID),
      ]),
      this.ruleFact.createRule(`${!shouldMarkDesignPackageRequired}`, [
        applyEffect(RuleAction.CLEAR_ERROR_MESSAGE),
        applyEffect(RuleAction.MAKE_NOT_REQUIRED),
      ]),

      this.ruleFact.createRule(`(${!isEhpDesignPackage})`, [
        {
          action: RuleAction.MAKE_HIDDEN,
          affectingType: 'group',
          applyTo: 'Heat Pump Information',
        },
      ]),
      this.ruleFact.createRule(`(${isEhpDesignPackage})`, [
        {
          action: RuleAction.MAKE_VISIBLE,
          affectingType: 'group',
          applyTo: 'Heat Pump Information',
        },
      ]),
    ];
  }

  private createBaseEffect(
    action: RuleAction,
    controlToApplyTo: string,
    value?: string,
  ): FormRuleEffect {
    return {
      action: action,
      affectingType: 'control',
      applyTo: controlToApplyTo,
      value: value,
    };
  }
}
